import { useConfirmModal } from "../pages/ConfirmModalContext";
import React, { useEffect, useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { NavLink, useNavigate } from 'react-router-dom';
import { Avatar } from 'primereact/avatar';
import { Ripple } from 'primereact/ripple';
import { StyleClass } from 'primereact/styleclass';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import { Tooltip, Whisper } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { toast } from "react-toastify";
import Loader2 from './Loader2';
import { getCurrentLanguage, t } from "../i18n";

const MenuItem = ({ to, icon, label, collapsed, onClick }) => {
  const link = (
    <NavLink
      to={to}
      className={({ isActive }) => isActive ? "active" : ""}
      onClick={onClick}
    >
      <i className={`pi ${icon}`}></i>
      {!collapsed && <span>{label}</span>}
      <Ripple />
    </NavLink>
  );

  return collapsed ? (
    <Whisper
      placement="right"
      trigger="hover"
      speaker={<Tooltip className="sidebar__tooltip">{label}</Tooltip>}
    >
      {link}
    </Whisper>
  ) : (
    link 
  );
};

const AppSidebar = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(getCurrentLanguage());
  const navigate = useNavigate();
  const tr = (key) => t(key, currentLanguage);
  const brokerType = String(localStorage.getItem("broker_type") || "").toLowerCase();
  const isGrowBroker = brokerType === "grow" || brokerType === "3";
  const isAngelOneBroker = brokerType === "angelone" || brokerType === "4";
  const showFnoNav = !isGrowBroker && !isAngelOneBroker;

  useEffect(() => {
    const handleLanguageChange = (event) => {
      setCurrentLanguage(event?.detail?.language || getCurrentLanguage());
    };
    window.addEventListener("app-language-change", handleLanguageChange);
    return () => window.removeEventListener("app-language-change", handleLanguageChange);
  }, []);

  const handleLogout = (e) => {
    // e.preventDefault();
    if (e) e.preventDefault();
    
    setIsLoggingOut(true);
    
    setTimeout(() => {
      localStorage.removeItem("sharedData");
      localStorage.removeItem("visibleColumns");
      
      toast.success(tr("loggedOutSuccessfully"));
      
      navigate("/");
      
      setIsLoggingOut(false);
    }, 1500);
  };


const { showConfirm } = useConfirmModal();

const handleLogoutClick = () => {
  showConfirm({
    message: "Are you sure you want to logout?",
    onConfirm: handleLogout, // API will be called ONLY after confirm
  });
};

  return (
    <>
      {isLoggingOut && <Loader2 loading={true} size={60} />}
      
      <div className={`app-sidebar ${collapsed ? "collapsed" : "expanded"}`}>
        {/* Toggle Button */}
        <div className="toggle-btn">
          <button onClick={() => setCollapsed(!collapsed)}>
            <i className={`pi ${collapsed ? "icon-down-arrow" : "icon-down-arrow"}`} />
          </button>
        </div>

        {/* Menu Items */}
        <ul className="menu">
          {/* {!isGrowBroker && (
          )} */}
            <li>
              <MenuItem to="/Dashboard" icon="icon-home" label={tr("dashboard")} collapsed={collapsed} />
            </li>
          {/* {!isGrowBroker && (
          )} */}
            <li>
              <MenuItem to="/Watchlist" icon="icon-watchlist" label={tr("watchlist")} collapsed={collapsed} />
            </li>
          <li>
            <MenuItem to="/Portfolio" icon="icon-portfolio" label={tr("portfolio")} collapsed={collapsed} />
          </li>

          <li>
            <MenuItem to="/Position" icon="icon-position" label={tr("position")} collapsed={collapsed} />
          </li>

         
            <li>
              <MenuItem to="/Order" icon="icon-order" label={tr("order")} collapsed={collapsed} />
            </li>
         
         
          {/* {!isGrowBroker && (
          )} */}
            <li>
              <MenuItem to="/OrderHistory" icon="icon-order-history" label={tr("orderHistory")} collapsed={collapsed} />
            </li>


              {!isGrowBroker && (
            <li>
              <MenuItem 
                to="/RollOver" 
                icon="icon-rollover"
                label={tr("rollOver")} 
                collapsed={collapsed} 
                />
            </li>
            )}
        
                {showFnoNav && (
                  <li>
                    {/* <MenuItem to="/FNO" icon="icon-fno" label={tr("fno")} collapsed={collapsed} /> */}
                    <MenuItem to="/FNO" icon="icon-position" label="FNO-360" collapsed={collapsed} />
                  </li>
                )}
        
        
        
        </ul>

        {/* Logout at Bottom */}
        {/* <div className="logout">
          <MenuItem 
          to="#" 
          icon="icon-logout" 
          label={tr("logout")} 
          collapsed={collapsed} 
          onClick={handleLogout}
          />
          </div> */}
        <div className="logout">
          <MenuItem 
            to="#" 
            icon="icon-logout" 
            label={tr("logout")} 
            collapsed={collapsed} 
            onClick={handleLogoutClick}
          />
        </div>
      </div>
    </>
  );
};

export default AppSidebar;
